import $ from 'jquery';

function imgAutoSize(Img, maxWidth, maxHeight) {
  // console.log(Img.width, 'ImgWidth');
  // console.log(Img.height, 'ImgHeight');
  Img.removeAttribute('width');
  Img.removeAttribute('height');
  if (maxWidth / maxHeight <= Img.width / Img.height) {
    Img.height = maxWidth * (Img.height / Img.width);
    // 以框的宽度为标准
    Img.width = maxWidth;
  } else {
    // 原图片宽高比例小于图片框宽高比例
    Img.width = maxHeight * (Img.width / Img.height);
    Img.height = maxHeight; // 以框的高度为标准
  }
}

export const imagePreview = {
  bind: function(el, binding) {
    const defaults = {
      imgSrc: '',
      clickPreviewInNewWindow: true,
      keepAspectRatio: true,
      maxRatioWidth: 150,
      maxRatioHeight: 150
    };

    let settings = $.extend({}, defaults, binding.value);

    // if (!settings.imgSrc) {
    //   return;
    // }

    let img = new Image();
    img.src = settings.imgSrc;

    let x = 10;
    let y = 20;
    let imageWidth = 600;
    let zoomRatio = 1;
    if (window.screen.width <= 1280) {
      zoomRatio = 0.9;
    }

    $(el)
      .mouseover(function(e) {
        // console.log(this.dataset.imgPreviewSrc, 'this.dataset.imageSrc');
        // console.group('aaa');
        // console.log('clientX:' + e.clientX);
        // console.log('clientY:' + e.clientY);
        // console.log('pageX:' + e.pageX);
        // console.log('pageY:' + e.pageY);
        // console.log('offsetX:' + e.offsetX);
        // console.log('offsetY:' + e.offsetY);
        // console.log('layerX:' + e.layerX);
        // console.log('layerY:' + e.layerY);
        // console.log('screenX:' + e.screenX);
        // console.log('screenY:' + e.screenY);
        // console.log('scrollLeft:' + document.documentElement.scrollLeft);
        // console.log('scrollTop:' + document.documentElement.scrollTop);
        // console.groupEnd('aaa');

        $('body').append(
          "<div id='imgPreviewContainer' style='z-index:9999'><img src='" + this.dataset.imgPreviewSrc + "' style='display:none'/></div>"
        );
        $('#imgPreviewContainer')
          .css({
            position: 'absolute',
            top: e.pageY / zoomRatio + y + 'px',
            left: e.pageX / zoomRatio + x + 'px'
          })
          .fadeIn(600);
        $('#imgPreviewContainer > img')[0].onload = function() {
          if (this.width < imageWidth && this.height < imageWidth) {
          } else {
            imgAutoSize(this, imageWidth, imageWidth);
          }
          $(this).css({
            display: 'inline-block'
          });
        };
      })
      .mouseout(function() {
        // img.title = img.myTitle;
        $('#imgPreviewContainer').remove();
      })
      .mousemove(function(e) {
        $('#imgPreviewContainer').css({
          top: e.pageY / zoomRatio + y + 'px',
          left: e.pageX / zoomRatio + x + 'px'
        });
      })
      .each(function() {
        var _this = this;
        if (settings.clickPreviewInNewWindow) {
          $(_this).click(function() {
            window.open(this.dataset.imgPreviewSrc);
          });
        }
      });
  },
  unbind(el) {
    console.log(el, 'image-zoom-in unbind');
  }
};
